import type { Language } from "../config/site";

export interface TextSection {
  heading: string;
  paragraphs: string[];
  bullets?: string[];
}

export interface LegalDocument {
  title: string;
  eyebrow: string;
  updatedLabel: string;
  updatedDate: string;
  introduction: string;
  sections: TextSection[];
}

export const navigation = {
  en: {
    home: "Home",
    privacy: "Privacy",
    terms: "Terms",
    support: "Support",
    play: "Web version",
    language: "Türkçe",
    languageLabel: "View this page in Turkish",
    skip: "Skip to content",
  },
  tr: {
    home: "Ana Sayfa",
    privacy: "Gizlilik",
    terms: "Koşullar",
    support: "Destek",
    play: "Web sürümü",
    language: "English",
    languageLabel: "View this page in English",
    skip: "İçeriğe geç",
  },
} satisfies Record<Language, Record<string, string>>;

export const common = {
  en: {
    nativeGame: "Native iOS game",
    contact: "Contact support",
    legalNote: "Clear rules. No ads, analytics or tracking.",
    footer: "A focused code-breaking game by Miraç Doğan in Türkiye.",
  },
  tr: {
    nativeGame: "Native iOS oyunu",
    contact: "Destek ile iletişim",
    legalNote: "Açık kurallar. Reklam, analytics veya tracking yok.",
    footer: "Türkiye'de Miraç Doğan tarafından geliştirilen odaklı bir kod çözme oyunu.",
  },
} satisfies Record<Language, Record<string, string>>;
